import { render, staticRenderFns } from "./userCliente.vue?vue&type=template&id=143f120b&scoped=true&"
import script from "./userCliente.vue?vue&type=script&lang=js&"
export * from "./userCliente.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=143f120b&scoped=true&lang=css&"
import style1 from "./userCliente.vue?vue&type=style&index=1&id=143f120b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143f120b",
  null
  
)

export default component.exports